import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { connect } from "react-redux";
import { setRoomId, setIsRoomHost, setIdentity, setIsRoomListener, setIsShowOverlay } from "../../stories/actions";
import { getIsRoomListeners } from "../../services/api";
import { toast } from "react-toastify";
import { headers } from "../../services/api";
import * as roomRTC from "../../services/roomRTC";

import "./Home.css";

const SERVER = process.env.REACT_APP_API_URL;

const SingleRoomListeners = ({ roomId, identity, isRoomHost, isCheckListener, authToken, username,
    setRoomIdAction, setIsRoomHostAction, setIdentityAction, setIsRoomListenerAction, setIsShowOverlayAction }) => {

    const navigateTo = useNavigate();

    const notify = (message) => {
        toast(message);
    };

    const roomListenerHandler = async () => {
        if (isCheckListener) {
            const roomResponse = await getIsRoomListeners(roomId);
            const { roomExists, full } = roomResponse;

            if (roomExists) {
                if (full) {
                    notify("A sala está em uso no momento. Por favor, tente novamente mais tarde.");
                } else {
                    setRoomIdAction(roomId);
                    setIsRoomHostAction(isRoomHost);
                    setIdentityAction(username);
                    setIsRoomListenerAction(true);
                    setIsShowOverlayAction(true);

                    navigateTo(`/home?itl=listener&session=${authToken}&host=${false}`);
                }
            } else {
                notify("Sala não encontrada.");
            }
        } else {
            notify("Esta sala é privada");
        }
    };

    return (
        <div className="item_room_listeners_container" onClick={roomListenerHandler}>
            <span>Sala iniciada por -</span>
            <b>{identity.toUpperCase()}</b>
            <span className="material-symbols-outlined icon_item_room_listeners">videocam_off</span>
            <span className="material-symbols-outlined icon_item_room_listeners">mic_off</span>
            {
                isCheckListener ?
                    <span className="material-symbols-outlined icon_item_room_listeners hearing">hearing</span> :
                    <span className="material-symbols-outlined icon_item_room_listeners hearing_disabled">hearing_disabled</span>
            }
        </div>
    );
};

const RoomListeners = ({ authToken, username, isRoomHost, identity, usuarioId, roomId, isOnlyAudio,
    isOnlyCamera, isCheckListener, setRoomIdAction, isRoomListener, setIsRoomHostAction,
    setIdentityAction, setIsRoomListenerAction, setIsShowOverlayAction }) => {
    const [allRooms, setAllRooms] = useState([]);

    const itlSearch = useLocation().search;

    const INTERVAL_TIME = 3000;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${SERVER}/room-search`, { headers });

                if (!response.ok) {
                    throw new Error(`Erro HTTP: ${response.status}`);
                }

                const data = await response.json();
                const model = data?.data?.model;

                if (model) {
                    setAllRooms(model);
                }
            } catch (error) {
                console.error("Erro ao buscar os dados:", error);
            }
        };

        fetchData();

        const interval = setInterval(fetchData, INTERVAL_TIME);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const fetchRoomListener = async () => {
            const isIdentityType = new URLSearchParams(itlSearch).get("itl");

            if (isRoomListener && isIdentityType) {
                await roomRTC.getInitialRoomConnection(isRoomHost, identity, usuarioId, roomId, isOnlyAudio, isOnlyCamera, isRoomListener);
            }
        };

        fetchRoomListener();
    }, [isRoomHost, identity, usuarioId, roomId, isOnlyAudio, isOnlyCamera, isCheckListener, isRoomListener]);

    return (
        <div className='row mb-4 room_listeners_container'>
            <div className="col-md-12 label_room_listeners_container">
                <div className="paragraph_room_listeners_container">
                    <span className="material-symbols-outlined icon_room_listeners">list</span>
                    <span className="paragraph_room_listeners">Quero ser ouvinte</span>
                </div>
                <span className="btn_room_listeners"></span>
            </div>

            <div className="col-md-12 list_room_listeners">
                {allRooms.length > 0 ? (
                    allRooms.map((room, index) => (
                        <SingleRoomListeners
                            key={`${room.roomId}${index}`}
                            roomId={room.roomId}
                            identity={room.identity}
                            isRoomHost={room.isRoomHost}
                            isCheckListener={room.isCheckListener}
                            authToken={authToken}
                            username={username}
                            setRoomIdAction={setRoomIdAction}
                            setIsRoomHostAction={setIsRoomHostAction}
                            setIdentityAction={setIdentityAction}
                            setIsShowOverlayAction={setIsShowOverlayAction}
                            setIsRoomListenerAction={setIsRoomListenerAction}
                        />
                    ))
                ) : (
                    <small className="label_overlay_listeners">Nenhuma sala está aberta.</small>
                )}
            </div>
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

const mapStateActionToProps = (dispatch) => {
    return {
        setRoomIdAction: (roomId) => dispatch(setRoomId(roomId)),
        setIdentityAction: (identity) => dispatch(setIdentity(identity)),
        setIsRoomHostAction: (isRoomHost) => dispatch(setIsRoomHost(isRoomHost)),
        setIsRoomListenerAction: (isRoomListener) => dispatch(setIsRoomListener(isRoomListener)),
        setIsShowOverlayAction: (isShowOverlay) => dispatch(setIsShowOverlay(isShowOverlay))
    };
};

export default connect(mapStoreToProps, mapStateActionToProps)(RoomListeners);